import type { MergeEntry } from "../types";

export interface MergeEdge {
  source: string;
  source_handler: string;
  target_handler: string;
  target_input_name: string;
}

export const serializeMergeEdges = (entries: MergeEntry[]): MergeEdge[] => {
  const edges: MergeEdge[] = [];

  entries.forEach((entry, index) => {
    if (!entry.nodeId) return;

    edges.push({
      source: entry.nodeId,
      source_handler: "success",
      target_handler: `merge-input-${index + 1}`,
      target_input_name: `entry_${index + 1}`,
    });
  });

  return edges;
};
